import React, { useCallback, useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { TogglelistOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, IconButton, Stack, Tooltip } from '@lyearn/ui';
import Tabs from '@/components/Tabs';
import { TabsProps } from '@/components/Tabs/types';
import ToggleList2Icon from '@/modules/corporate/modules/course/views/CourseViewer/components/Sidebar/Header/ToggleList2Icon';

interface SidebarTabsProps<T extends string> extends TabsProps<T> {
  boxStyles?: string;
  showSubLessons?: boolean;
  toggleShowSubLessons?: () => void;
  toggleShowLessonsSearch?: () => void;
}

function SidebarTabs<T extends string>(props: SidebarTabsProps<T>) {
  const {
    boxStyles = '',
    showSubLessons,
    toggleShowSubLessons,
    toggleShowLessonsSearch,
    ...restProps
  } = props;

  const { t } = useTranslation();

  const onToggleSubLessons = useCallback(() => {
    toggleShowSubLessons?.();
  }, [toggleShowSubLessons]);

  const subLessonsToggle = useMemo(() => {
    if (showSubLessons === undefined) {
      return null;
    }
    return (
      <Tooltip title={t('Course:Viewer:ToggleSubLessons')}>
        <IconButton onClick={onToggleSubLessons}>
          {!showSubLessons ? <TogglelistOutline /> : <ToggleList2Icon />}
        </IconButton>
      </Tooltip>
    );
  }, [t, onToggleSubLessons, showSubLessons]);

  return (
    <Box
      className={cn(
        'flex flex-row h-48 w-full flex-shrink-0 items-end border-b border-divider px-20 justify-between',
        boxStyles,
      )}>
      <Tabs variant="small" {...restProps} />
      <Stack className="self-center" gapX={8}>
        {subLessonsToggle}
        {/* <Tooltip title={t('Common:Search')}>
          <IconButton onClick={toggleShowLessonsSearch}>
            <SearchOutline height={20} width={20} />
          </IconButton>
        </Tooltip> */}
      </Stack>
    </Box>
  );
}

export default React.memo(SidebarTabs);
